CcrisDerivatives.vue


<template>
    <div class="ccris-derivatives">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <b-row align-v="center">
                    <b-col cols="6">
                        <h4 class="mb-0">CCRIS Derivatives</h4>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_ccris_derivatives_full_view = true" class="full-view-link">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-table-simple responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Facilities</b-th>
                        <b-th class="text-right">Secured</b-th>
                        <b-th class="text-right">Unsecured</b-th>
                        <!-- <b-th class="text-white" v-for="person in tableData" :key="person.name" :scope="'col'">{{ person.name }}</b-th> -->
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-th scope="row"># of facilities</b-th>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_sec_total || '0' | fixNumberFormat }}</b-td>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_total || '0' | fixNumberFormat }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Outstanding (RM)</b-th>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_sec_out_balance | moneyFormatter }}</b-td>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_out_balance | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Outstanding (%)</b-th>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_sec_out_limit }}</b-td>
                        <b-td class="text-right">{{ tableData.ccris_drv_fac_unsec_out_limit }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
        <CcrisDerivativesModal 
            :show_ccris_derivatives_full_view.sync="modals.show_ccris_derivatives_full_view"
            :customer-id="customerId"
            :ccris-derivatives="tableData"
            :report-data-ccris-derivatives="reportDataCcrisDerivatives"
        />
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'
    import { mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import CcrisDerivativesModal from '@/views/CustomerProfile/CustomerModals/CcrisDerivativesModal.vue'

    export default {
        name: 'ccris-derivatives',
        props: ['ccris-derivatives'],
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            CcrisDerivativesModal
        },
        computed: {
            ...mapState(useCustomerStore, ['current_customer', 'current_commitment']),
            customerId() {
                return this.current_customer && this.current_customer.customer_id ? this.current_customer.customer_id : (this.$route.params.customer_id || null)
            },
            tableData() {
                return this.ccrisDerivatives || {}
            },
            // b = report_data.ccris_derivatives
            reportDataCcrisDerivatives() {
                return this.current_commitment && this.current_commitment.report_data && this.current_commitment.report_data.ccris_derivatives 
                    ? this.current_commitment.report_data.ccris_derivatives 
                    : {}
            }
        },
        data() {
            return {
                modals: {
                    show_ccris_derivatives_full_view: false
                }
            }
        },
    }
</script>